import React from 'react'
import PropTypes from 'prop-types'

/**
 * @author ehernandez
 * @returns {React.Component}
 */
const Body = ({ className, children }) => {
  return (
    <div className={`${className} tw-flex-1`}>
      {children}
    </div>
  )
}

Body.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default Body
